module.exports = __webpack_public_path__ + "assets/hanbao.4c41dbe5.svg";